import BrowserEventBus from "./browser";
import * as EVENTS from "./events";
window.eventbus = BrowserEventBus();
window.EVENTS = EVENTS;
export { EVENTS };
export default eventbus;